<div class="container pr-0">
    <div *ngIf="enableLoader" id="loader"></div>
<!-- <div *ngIf="inventoryTab=='active'">
    <div class="card" *ngFor="let publishedData of publishedData; let i=index">
        <div class="card-body p-0 border-radius-05" data-parent='#example'>
            <div class="d-flex p-1 pl-4 pr-4 stripe" [ngClass]="productInfo.headerColor">
                <div class="strong text-white">{{productInfo.shortDescription}}</div>
                <div class="d-flex ml-auto">
                    <div class="strong text-white mr-4">Batch ID: {{publishedData.batches.batchId}}</div>
                    <div class="strong text-white mr-4">Creation date: {{publishedData.batches.creationDate}}</div>
                </div>
            </div>
            <div class="card-title">
                <div class="d-flex justify-content-between mt-2 ml-4 pb-0">
                    <div class="fs-24 strong pb-4">
                        <div class="h5 mb-0 fw-bold">{{productInfo.name}}</div>

                        <div class="h5 mb-0 text-secondary">{{port.name}}</div>
                    </div>
                    <div class=" d-flex pb-0">
                        <div class="visible-xs ">
                            <div class="small text-secondary">Listing Price</div>
                            <div class="strong"> 70000 </div>
                        </div>
                        <div class="visible-xs ml-5">
                            <div class="small text-secondary">In Negotiation</div>
                            <div class="strong"> 70000 </div>
                        </div>
                        <div class="visible-xs ml-5">
                            <div class="small text-secondary">Initial Stock</div>
                            <div class="strong"> 70000 </div>
                        </div>
                        <div class="visible-xs ml-5">
                            <div class="small text-secondary">Stock Sold</div>
                            <div class="strong"> 70000 </div>
                        </div>
                        <div class="visible-xs ml-5">
                            <div class="small text-secondary">Collected</div>
                            <div class="strong"> 70000 </div>
                        </div>
                        <div class="visible-xs ml-5">
                            <div class="small text-secondary">To pick up</div>
                            <div class="strong"> 70000 </div>
                        </div>
                        <div class="visible-xs ml-5 mr-5">
                            <div class="small text-secondary">Tradable Balance</div>
                            <div class="strong"> 70000 </div>
                        </div>
                    </div>

                </div>
                <div class="hr"></div>
                <div class="inside-layout  align-self-stretch">
                    <div class="viewdetails hidden-xs ">
                        <a class="strong  btn btn-link">
              {{ 'home.quote.Viewdetails' | cxTranslate }} ></a>
                    </div>
                </div>
            </div>
        </div>
 </div>
 </div>
 <div *ngIf="inventoryTab=='completed'"> -->
     <!-- <div class="card" *ngFor="let unpublished of unpublishedData; let i=index">
        <div class="card-body p-0 border-radius-05" data-parent='#example'>
            <div class="d-flex p-1 pl-4 pr-4 stripe" [ngClass]="productInfo.headerColor">
                <div class="strong text-white">{{productInfo.shortDescription}}</div>
                <div class="d-flex ml-auto">
                    <div class="strong text-white mr-4">Batch ID: {{unpublished.batches.batchId}}</div>
                    <div class="strong text-white mr-4">Creation date: {{unpublished.batches.creationDate}}</div>
                </div>
            </div>
            <div class="card-title">
                <div class="d-flex justify-content-between mt-2 ml-4 pb-0">
                    <div class="fs-24 strong pb-4">
                        <div class="h5 mb-0 fw-bold">{{productInfo.name}}</div>

                        <div class="h5 mb-0 text-secondary">{{port.name}}</div>
                    </div>
                    <div class=" d-flex pb-0">
                        <div class="visible-xs ">
                            <div class="small text-secondary">Listing Price</div>
                            <div class="strong"> 70000 </div>
                        </div>
                        <div class="visible-xs ml-5">
                            <div class="small text-secondary">In Negotiation</div>
                            <div class="strong"> 70000 </div>
                        </div>
                        <div class="visible-xs ml-5">
                            <div class="small text-secondary">Initial Stock</div>
                            <div class="strong"> 70000 </div>
                        </div>
                        <div class="visible-xs ml-5">
                            <div class="small text-secondary">Stock Sold</div>
                            <div class="strong"> 70000 </div>
                        </div>
                        <div class="visible-xs ml-5">
                            <div class="small text-secondary">Collected</div>
                            <div class="strong"> 70000 </div>
                        </div>
                        <div class="visible-xs ml-5">
                            <div class="small text-secondary">To pick up</div>
                            <div class="strong"> 70000 </div>
                        </div>
                        <div class="visible-xs ml-5 mr-5">
                            <div class="small text-secondary">Tradable Balance</div>
                            <div class="strong"> 70000 </div>
                        </div>
                    </div>

                </div>
                <div class="hr"></div>
                <div class="inside-layout  align-self-stretch">
                    <div class="viewdetails hidden-xs ">
                        <a class="strong  btn btn-link">
              {{ 'home.quote.Viewdetails' | cxTranslate }} ></a>
                    </div>
                </div>
            </div>

        </div>
 </div> -->
 <div  infiniteScroll [infiniteScrollDistance]="1" [infiniteScrollThrottle]="50" (scrolled)="onScrollGrid()" [scrollWindow]="true">
    <div *ngIf="inventoryTab=='active'">
        <app-custom-inventory-content [grid]='grid' [list]='list' [Data]='publishedData'></app-custom-inventory-content>
        </div>
     <div *ngIf="inventoryTab=='completed'">
        <app-custom-inventory-content [grid]='grid' [list]='list' [Data]='unpublishedData'></app-custom-inventory-content>
     </div>
     <div *ngIf="inventoryTab=='archived'">
         <app-custom-inventory-content [grid]='grid' [list]='list' [Data]='archivedData'></app-custom-inventory-content>
     </div>
</div>
 
 <!-- <div *ngIf="inventoryTab=='archived'">
     <div class="card" *ngFor="let archived of archivedData; let i=index">
        <div class="card-body p-0 border-radius-05" data-parent='#example'>
            <div class="d-flex p-1 pl-4 pr-4 stripe" [ngClass]="productInfo.headerColor">
                <div class="strong text-white">{{productInfo.shortDescription}}</div>
                <div class="d-flex ml-auto">
                    <div class="strong text-white mr-4">Batch ID: {{archived.batches.batchId}}</div>
                    <div class="strong text-white mr-4">Creation date: {{archived.batches.creationDate}}</div>
                </div>
            </div>
            <div class="card-title">
                <div class="d-flex justify-content-between mt-2 ml-4 pb-0">
                    <div class="fs-24 strong pb-4">
                        <div class="h5 mb-0 fw-bold">{{productInfo.name}}</div>

                        <div class="h5 mb-0 text-secondary">{{port.name}}</div>
                    </div>
                    <div class=" d-flex pb-0">
                        <div class="visible-xs ">
                            <div class="small text-secondary">Listing Price</div>
                            <div class="strong"> 70000 </div>
                        </div>
                        <div class="visible-xs ml-5">
                            <div class="small text-secondary">In Negotiation</div>
                            <div class="strong"> 70000 </div>
                        </div>
                        <div class="visible-xs ml-5">
                            <div class="small text-secondary">Initial Stock</div>
                            <div class="strong"> 70000 </div>
                        </div>
                        <div class="visible-xs ml-5">
                            <div class="small text-secondary">Stock Sold</div>
                            <div class="strong"> 70000 </div>
                        </div>
                        <div class="visible-xs ml-5">
                            <div class="small text-secondary">Collected</div>
                            <div class="strong"> 70000 </div>
                        </div>
                        <div class="visible-xs ml-5">
                            <div class="small text-secondary">To pick up</div>
                            <div class="strong"> 70000 </div>
                        </div>
                        <div class="visible-xs ml-5 mr-5">
                            <div class="small text-secondary">Tradable Balance</div>
                            <div class="strong"> 70000 </div>
                        </div>
                    </div>

                </div>
                <div class="hr"></div>
                <div class="inside-layout  align-self-stretch">
                    <div class="viewdetails hidden-xs ">
                        <a class="strong  btn btn-link">
              {{ 'home.quote.Viewdetails' | cxTranslate }} ></a>
                    </div>
                </div>
            </div>

        </div>
    </div> -->
</div>